import { BaseWidgetModel } from './base'
import {
  generateDefaultBackground
} from '~/site/model/helper'

import { LayoutPositionEnum } from '~/enums/data'
import { hasOwn } from '~/utils'
import { DefaultImage } from '~/enums/defaultImageEnum'
import { ModuleNameEnum, WidgetModelNames } from '~/enums/siteEnum'

/**
 * 客服模型
 */
export class SupportSettingWidgetModel extends BaseWidgetModel {
  constructor(options) {
    super(options)
    this.name = WidgetModelNames.SupportSettingWidgetModel
    this.title = options?.title || 'supportSetting'
    this.floatEnabled = hasOwn(options, 'floatEnabled', '', false)
    this.moduleName = ModuleNameEnum.CustomerService
    this.layout = hasOwn(options, 'layout', '', LayoutPositionEnum.BottomRight)
    this.type = hasOwn(options, 'type', '', null)
    this.logo = hasOwn(options, 'logo', '', generateDefaultBackground({ backgroundImage: DefaultImage.CustomerLogo }))

    this.getMenuInfo = () => {
      return {
        id: this.id,
        title: 'supportSetting',
        name: this.moduleName,
        icon: 'icon-customer-nor',
        draggable: false,
        isDefault: false
      }
    }
  }
}
